import React from "react";
import MarketingProductSection from "./MarketingProductSection";
import MarketingCommunityPreview from "./MarketingCommunityPreview";

const MarketingCommunitySection = ({ onStart }) => (
  <MarketingProductSection
    tone="black"
    chip="Community"
    title="Build it. Challenge it. Vote."
    body="Turn a sports take into a debate, a challenge, or a roster battle. The crowd picks a side. The record keeps score."
    ctaLabel="Join the Community"
    onCta={onStart}
  >
    <MarketingCommunityPreview />
  </MarketingProductSection>
);

export default MarketingCommunitySection;
